export default {"git_sha": "b71ea70"} // eslint-disable-line
